import { useQuery } from '@tanstack/react-query'

import { SupportAttendanceStatsParams } from '@/app/services/supportRequestService/getSupportAttendanceStats'
import { supportRequestService } from '@/app/services/supportRequestService'

export const SUPPORT_ATTENDANCE_STATS_QUERY_KEY = 'supportAttendanceStats'

export const useSupportAttendanceStats = (
  params: SupportAttendanceStatsParams = {},
  enabled = true,
) =>
  useQuery({
    queryKey: [SUPPORT_ATTENDANCE_STATS_QUERY_KEY, params],
    queryFn: () => supportRequestService.getSupportAttendanceStats(params),
    staleTime: 60_000,
    enabled,
  })
